moment = require("moment")
_ = require("lodash")

DashboardBestScoreCtrl = ($scope, $location, DashboardService) ->
  $scope.isLoading = true
  $scope.bestScores = []

  processData = (data) ->
    data.map (item) ->
      _.merge {}, item,
        play_date: moment(item.play_date).format("YYYY/MM/DD")

  $scope.classForRoundIcons = (item) ->
    switch item.round_type
      when 1.5 then 'icons-extra9'
      when 0.5 then 'icons-half-nine'
      else ''

  $scope.showScoreCardDetail = (id) ->
    $location.path("/round-detail/#{id}")

  createMyAnalysisParams = ->
    from: $scope.startDate
    to: $scope.endDate
    round_type: $scope.roundType

  callMyAnalysis = (params = {}) ->
    $scope.isLoading = true
    DashboardService.getBestScores(params)
      .then (res) ->
        $scope.bestScores = processData(res.best_scores)
      .finally ->
        $scope.isLoading = false

  $scope.$parent.$on "periodSelected.gnp.dashboard", (event, startDate, endDate, roundType) ->
    $scope.startDate = startDate?.clone()
    $scope.endDate = endDate?.clone()
    $scope.roundType = roundType
    params = createMyAnalysisParams()
    callMyAnalysis(params)

  $scope.$parent.$on "roundTypeUpdated.gnp.dashboard", (event, roundType) ->
    $scope.roundType = roundType
    params = createMyAnalysisParams()
    callMyAnalysis(params)

DashboardBestScoreCtrl.$inject = [
  '$scope'
  '$location'
  'DashboardService'
]

module.exports = DashboardBestScoreCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/best-score/best-score-controller.coffee